import React, {useState, useEffect, useRef} from 'react';
import Rodal from "rodal";
import {createClient} from 'pexels';
import 'rodal/lib/rodal.css';
import '../css/tabs.css';
import '../css/rodal.css';
import '../css/pexels.css';

import $ from 'jquery';
import isImageUrl from 'is-image-url';
import InstagramApi from "simple-instagram-api";
import instagramGetUrl from "instagram-url-direct";
import PexelPhoto from './PexelPhoto';
import PexelVideo from './PexelVideo';
import axios from 'axios';

const client = createClient(process.env.REACT_APP_PEXELS_API_KEY);

export default function EmbedInstagram(props) {

    const [playerUrl, setPlayerUrl] = useState(null);
    const [url, setUrl] = useState(null);
    const [contentDisplay, setContentDisplay] = useState(false);
    const [mediaType, setMediaType] = useState(`video`);

    useEffect(() => {
        const input = document.getElementById('txt-embed-url')
        input.setAttribute("autofocus", "");
        input.focus()
        input.select()
    }, []);
    
    const styles = {
        background: '#191A1F',
        width: '70%',
        height: 'fit-content',
        maxHeight: 'calc(100vh - 100px)',
        overflowY: 'hidden',
    };


    const handleValidate = async () => {
        // document.getElementById('txt-embed-url').classList.add('is-invalid');
        // document.getElementById('txt-embed-url').classList.remove('is-valid');
        const url = document.getElementById('txt-embed-url').value || ``;
        // if (url.length === 0) {
        //     return;
        // }

        // const pattern = /(https?:\/\/(?:www\.)?instagram\.com\/p\/([^/?#&]+)).*/g;
        // if (pattern.test(url)) {
        //     document.getElementById('txt-embed-url').classList.remove('is-invalid');
        //     document.getElementById('txt-embed-url').classList.add('is-valid');


        const instaSource = await axios.get(url);
        console.log(instaSource);
        // const instaObj = instaSource.data
        // .match(
        //     /<script type="text\/javascript">window\._sharedData = (.*)<\/script>/
        // )[1].slice(0,-1);

        // const convertedJsonObj = JSON.parse(instaObj);
        // console.log(convertedJsonObj);

            // fetch(url)
            //     .then(response => response.text())
            //     .then(pageSource => console.log(pageSource));
            // const code = url.split("/p/")[1].replace("/", "");
            // console.log(code);
            // let links = await instagramGetUrl(url)
            // console.log(links)
            // InstagramApi.get(code).then(result => {
            //     console.log(result);
            // });

            if (isImageUrl(url)) {
                setMediaType('image');
            } else {
                setMediaType('video');
            }
            setPlayerUrl(url);
            setContentDisplay(true);
            setUrl(url);
        // }

        /*if (url.endsWith(`.png`) || url.endsWith(`.jpg`) || url.endsWith(`.jpeg`)
            || (url.includes(`data:`) && url.includes(`base64`))) {
            document.getElementById('txt-embed-url').classList.remove('is-invalid');
            document.getElementById('txt-embed-url').classList.add('is-valid');
            setMediaType('image');
            setUrl(url);
        }*/
    }

    const handleSelect = () => {
        if (document.getElementById('txt-embed-url').className.split(' ').indexOf('is-valid') !== -1) {
            props.onSelect(url, mediaType);
            props.onClose();
        } else {
            document.getElementById('txt-embed-url').classList.add('is-invalid');
            document.getElementById('txt-embed-url').classList.remove('is-valid');
        }
    }

    return (
        <Rodal visible={true}
               onClose={() => props.onClose()}
               closeOnEsc={false}
               closeMaskOnClick={true}
               customStyles={styles}>
            <div className="container">
                <div className="row mt-30">
                    <div className="col-12">
                        <img src="https://www.instagram.com/p/CG3Mu-TBinL/?utm_source=ig_web_copy_link"></img>
                        <input type="text" className="form-control form-control-3" id="txt-embed-url"
                               placeholder="Paste an Instagram post link"
                               onChange={handleValidate}/>
                        {/*<div className="valid-feedback text-left">
                            Looks good!
                        </div>*/}
                        <div className="invalid-feedback text-left">
                            Please provide a valid Instagram post address.
                        </div>
                    </div>
                </div>
                <div className="row mt-10" style={contentDisplay ? {} : {display: "none"}}>
                    <div className="col-12 pexel-gallery">
                        {mediaType === 'video' && playerUrl && 
                            <iframe id="player" className="embed-player"
                                src={playerUrl}
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen></iframe>}

                        {mediaType === 'image' && url && <img id="player" className="embed-player" src={url}/>}
                    </div>
                </div>
                <div className="row" style={contentDisplay ? {} : {display: "none"}}>
                    <div className="col text-right mt-10">
                        {/*<button className="btn btn-styled mt-0 btn-new m-1" onClick={e => props.onClose()}>Close</button>*/}
                        <button className="btn btn-styled mt-0 btn-new m-1" id="select-button"
                                onClick={handleSelect}>Select Video
                        </button>
                    </div>
                </div>
            </div>
        </Rodal>
    );
}